import React from 'react'
import LoadingOverlay from 'react-loading-overlay'

const TemplateDeleteBox = (props) => {

    return (
        <LoadingOverlay active={props.loading} spinner>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Confirmation</h5>
            <button
              type="button"
              onClick={() => props.setShowDeleteConfirm(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" onClick={() => props.setShowDeleteConfirm(false)}>
                &times;
              </span>
            </button>
          </div>
    
          <div className="modal-body">
            Are you sure you want to delete the template{" "}
            <span className="text-primary">
              {props.template.name}
            </span>{" "}
            ?
          </div>
    
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => props.deleteTemplate()}
            >
              Delete
            </button>
            <button
              type="button"
              className="btn btn-secodnary"
              onClick={() => props.setShowDeleteConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </LoadingOverlay>
      )
}

export default TemplateDeleteBox